const initialData = {
	steps: {
		'step-1': {
			id: 'step-1',
			content: 'We admitted we were powerless over alcohol – that our lives had become unmanageable.',
		},
		'step-2': {
			id: 'step-2',
			content: 'Came to believe that a Power greater than ourselves could restore us to sanity.',
		},
		'step-3': {
			id: 'step-3',
			content: 'Made a decision to turn our will and our lives over to the care of God as we understood Him.',
		},
		'step-4': {
			id: 'step-4',
			content: 'Made a searching and fearless moral inventory of ourselves.',
		},
		'step-5': {
			id: 'step-5',
			content: 'Admitted to God, to ourselves, and to another human being the exact nature of our wrongs.',
		},
		'step-6': {
			id: 'step-6',
			content: 'Were entirely ready to have God remove all these defects of character.',
		},
		'step-7': {
			id: 'step-7',
			content: 'Humbly asked Him to remove our shortcomings.',
		},
		'step-8': {
			id: 'step-8',
			content: 'Made a list of all persons we had harmed, and became willing to make amends to them all.',
		},
		'step-9': {
			id: 'step-9',
			content:
				'Made direct amends to such people wherever possible, except when to do so would injure them or others.',
		},
		'step-10': {
			id: 'step-10',
			content: 'Continued to take personal inventory and when we were wrong promptly admitted it.',
		},
		'step-11': {
			id: 'step-11',
			content:
				'Sought through prayer and meditation to improve our conscious contact with God as we understood Him, praying only for knowledge of His will for us and the power to carry that out.',
		},
		'step-12': {
			id: 'step-12',
			content:
				'Having had a spiritual awakening as the result of these steps, we tried to carry this message to alcoholics, and to practice these principles in all our affairs.',
		},
		'hipster-1': {
			id: 'hipster-1',
			content:
				'Admitting defeat, we understood our lack of control over alcohol had caused our lives to spiral out of control. #YOLO #SayNoToAlcohol',
		},
		'hipster-2': {
			id: 'hipster-2',
			content:
				'Believing in something bigger than ourselves can bring us back to reality. #TrustTheProcess, #BeReal #RestoreSanity',
		},
		'hipster-3': {
			id: 'hipster-3',
			content:
				'We chose to put our trust in God and hand our lives over to Him; we understand Him the best. #trustGod #decision',
		},
		'hipster-4': {
			id: 'hipster-4',
			content: 'We took a deep, real look at ourselves and our morals. Got honest with ourselves and checked in.',
		},
		'hipster-5': {
			id: 'hipster-5',
			content: 'Confess 2 God, ourselves, and a homie the real deal of our mess-ups.',
		},
		'hipster-6': {
			id: 'hipster-6',
			content: "Ready 2 let God take away our flaws? Let's do dis, y'all!",
		},
		'hipster-7': {
			id: 'hipster-7',
			content: 'We humbly asked the Almighty to help us overcome our flaws. #blessup',
		},
		'hipster-8': {
			id: 'hipster-8',
			content:
				'Posted my wrongs & vowed 2 make amends 2 everyone I hurt. Time 2 accept responsibility & do the work 2 make things right. #OwningMyMistakes #Grateful4TheGrowth',
		},
		'hipster-9': {
			id: 'hipster-9',
			content:
				'Apologize to those affected, unless it could hurt them or someone else. Do what you can to make things right! #SorryNotSorry',
		},
		'hipster-10': {
			id: 'hipster-10',
			content: 'We kept up with self-reflection, and when we messed up we owned up to it pronto.',
		},
		'hipster-11': {
			id: 'hipster-11',
			content:
				'Seeking a stronger connection with the divine, we pray for clarity and the strength to carry out His will. #DivineConnection #PowerOfPrayer #Grateful',
		},
		'hipster-12': {
			id: 'hipster-12',
			content:
				'After our spiritual transformation from doing the steps, we shared our message with those struggling with alcohol and applied the principles to our everyday lives. #StepsWork #SpiritualGrowth #RiseUp',
		},
	},
	columns: {
		step: {
			id: 'step',
			title: "A.A.'s 12 Steps",
			stepIds: [
				'step-1',
				'step-11',
				'step-10',
				'step-3',
				'step-12',
				'step-9',
				'step-4',
				'step-7',
				'step-6',
				'step-8',
				'step-2',
				'step-5',
			],
		},
		hipster: {
			id: 'hipster',
			title: 'Hipster Crap',
			stepIds: [
				'hipster-1',
				'hipster-12',
				'hipster-7',
				'hipster-8',
				'hipster-10',
				'hipster-2',
				'hipster-11',
				'hipster-5',
				'hipster-3',
				'hipster-9',
				'hipster-6',
				'hipster-4',
			],
		},
	},
	columnOrder: ['step', 'hipster'],
};

export default initialData;
